<div class="unsaved-changes-dialog">
  <button mat-icon-button class="close-button" (click)="onCancel()">
    <mat-icon>close</mat-icon>
  </button>
  <div class="dialog-header">
    <div class="icon-container">
      <mat-icon>warning</mat-icon>
    </div>
    <h2 mat-dialog-title>
      Unsaved {{ data.entityName ? data.entityName + ' ' : '' }}Changes
    </h2>
  </div>
  <mat-dialog-content>
    <p>You have unsaved changes. What would you like to do?</p>
    @if (data.hasValidationErrors && !data.continueEditingOnly) {
      <p class="validation-message">
        {{
          data.validationErrorMessage ||
            'Complete all required fields before saving your changes.'
        }}
      </p>
    }
  </mat-dialog-content>
  <div class="dialog-actions">
    <button mat-stroked-button (click)="onDiscard()" class="discard-button">
      Discard Changes
    </button>
    @if (data.continueEditingOnly || data.hasValidationErrors) {
      <button mat-raised-button (click)="onCancel()" class="continue-button">
        Continue Editing
      </button>
    } @else {
      <button mat-raised-button (click)="onSave()" class="save-button">
        Save Changes
      </button>
    }
  </div>
</div>
